module.exports = __webpack_public_path__ + "img/image02.e3511cf8.jpg";